import React from 'react';
import { useIntl } from 'react-intl';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { reviewMessages } from './reviewMessages';
import type { ReviewProblem } from './reviewRules';

interface ReviewConsentFieldProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  problem: ReviewProblem | undefined;
  disabled: boolean;
}

/** The consent to publish (design review-form a1). The server refuses a review without it. */
const ReviewConsentFieldComponent: React.FC<ReviewConsentFieldProps> = ({ checked, onChange, problem, disabled }) => {
  const intl = useIntl();
  return (
    <FormGroup check className="mb-0">
      <Input
        id="reviewConsent"
        type="checkbox"
        checked={checked}
        invalid={problem !== undefined}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <Label check for="reviewConsent">
        {intl.formatMessage(reviewMessages.consentLabel)}
      </Label>
      {problem !== undefined && <FormFeedback>{intl.formatMessage(reviewMessages.consentMissing)}</FormFeedback>}
    </FormGroup>
  );
};

export const ReviewConsentField = TypedMemo(ReviewConsentFieldComponent);
